$(document).on('ready page:load', function() {
  if($(window).width() <= 768) {
    $('.element-separator .direction-y:not(.has_icon)')
      .removeClass('direction-y')
      .addClass('direction-x')
  }
});
